module.exports = __webpack_public_path__ + "img/anti_air_tower_small.9b1e353a.png";